// import GiftOtp from "components/Auth/GiftOtp"
import GiftOtp from "components/Auth/GiftOtp"
import TrialReset from "components/Auth/trial-reset"
import TrialVerification from "components/Auth/trial-verification"
import { pathApp } from "services/utiles"

// const pathApp = '/app'

const PrivateRoutesTrial = [
  { path: `${pathApp}trial-otp`, name: 'Dashboard', component: GiftOtp },

  // { path: '/trial-verification', name: 'Dashboard', component: TrialVerification },
  {
    path: `${pathApp}trial/forgot-verification`,
    name: "Dashboard",
    component: TrialVerification,
  },
  {
    path: `${pathApp}trial/reset-password`,
    name: "Dashboard",
    component: TrialReset,
  },
]
export default PrivateRoutesTrial
